import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ZipCodeInfoService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('ZipCodeInfo');
	}

	loadAll(): Observable<any> {
		return this.myBaseService.loadAll(this.url);
	}

	loadAllForDeliveryZoneGroup(deliveryZoneGroupID: string): Observable<any> {
		var iUrl = this.url + '/ForGroup/' + (deliveryZoneGroupID || '');
		return this.myBaseService.loadAll(iUrl);
	}

	loadAllForCustomerDeliveryZoneGroup(customerID: string, deliveryZoneGroupID: string): Observable<any> {
		var iUrl = this.url + '/ForCustomerGroup/' + (customerID || '') + '/' + (deliveryZoneGroupID || '');
		return this.myBaseService.loadAll(iUrl);
	}

	loadAllForRectangle(neLat: number, neLng: number, swLat: number, swLng: number,
		groupID: string, customerID: string): Observable<any> {
		var iUrl = this.url;
		iUrl += '/ForRectangle?NELat=' + (neLat.toString());
		iUrl += '&NELng=' + (neLng.toString());
		iUrl += '&SWLat=' + (swLat.toString());
		iUrl += '&SWLng=' + (swLng.toString());
		if (groupID) {
			iUrl += '&groupID=' + groupID;
		}
		if (customerID) {
			iUrl += '&customerID=' + customerID;
		}
		return this.myBaseService.loadAll(iUrl);
	}

}

